import React from 'react';
import Alert from '../../../components/alert';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { IPostCreateOrderResponseData } from '../../../actions/post-create-order.action';

export const OrderError = ({ resources, orderData }: { resources: ILxsCreateOrderResources; orderData: IPostCreateOrderResponseData }) => {
    return (
        <>
            <Alert type='danger' message={resources.createOrderErrorCreateOrder} iconSize={1} />
            <p>{resources.createOrderErrorCreateOrderHint}</p>
            <ul>
                {orderData.Messages.map(error => (
                    <li key={error.ReturnCode}>
                        {resources.globalErrorCodeLabel} {error.ReturnCode}
                    </li>
                ))}
            </ul>
        </>
    );
};
